@if (tailoringConditions) {
	<article>
		<ul class="list dense">
			@for (entry of tailoringConditions | mergeConditions; track entry) {
				<li class="list-item">
					<div class="query">
						@if (entry.breadcrumb) {
							<span class="h6">{{ entry.breadcrumb }}</span>
						}
						<span class="h4">{{ entry.query.name }}</span>
						<ul class="list dense">
							@for (answer of entry.query.answers; track answer) {
								<li class="answer">
									@if (answer.allowedOperations.ACCESS_TAILORING_RESOURCES) {
										<a [routerLink]="['../../../management/tailoring/' + answer.identity]">
											<span class="h4">{{ answer.name }}</span>
										</a>
									}
									@if (!answer.allowedOperations.ACCESS_TAILORING_RESOURCES) {
										<span class="h4">{{ answer.name }}</span>
									}
									@for (type of answer.conditionTypes; track type) {
										<p class="subtypes" translate="management.tailoring.answer.{{ type }}"><!--remove span--></p>
									}
								</li>
							}
						</ul>
					</div>
				</li>
			}
		</ul>
	</article>
} @else {
	@if (translateNone) {
		<article>
			<p class="empty" [translate]="translateNone"></p>
		</article>
	}
}
